<div mat-dialog-title>
  <span>{{data.title}}</span>
  <button type="button" class="dna-dialog-close" mat-dialog-close aria-label="Fechar">
    <span class="material-icons">close</span>
  </button>
</div>

<mat-dialog-content class="mat-typography mb-4 dna-message-dialog-content">
  <h3 style="font-weight: bold">{{data.detail}}</h3>
  <div class="dna-dialog-message" *ngFor="let message of data.message">
    {{message}}
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button [mat-dialog-close]="true" mat-button cdkFocusInitial>Confirmar</button>
  <button mat-button mat-dialog-close>Cancelar</button>
</mat-dialog-actions>
